/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import React, { forwardRef } from "react";

import cn from "classnames";

import DropDownAnchor from "./components/DropDownAnchor";
import Menu from "./components/DropDownMenu";

interface DropdownProps
  extends React.ForwardRefExoticComponent<
    React.HTMLAttributes<HTMLDivElement> & {
      className?: string;
      children: React.ReactNode;
      ref?: React.ForwardedRef<HTMLDivElement>;
    }
  > {
  Anchor: typeof DropDownAnchor;
  Menu: typeof Menu;
}

const DropDown = forwardRef(({ children, className = "" }, ref) => {
  return (
    <div
      ref={ref ? ref : null}
      className={cn("h-full relative", className)}
      test-id="p5Gqt6Pw"
    >
      {children}
    </div>
  );
}) as DropdownProps;

DropDown.Anchor = DropDownAnchor;
DropDown.Menu = Menu;

export default DropDown;
